import { render, staticRenderFns } from "./neworder.vue?vue&type=template&id=2e074a0a&scoped=true&"
import script from "./neworder.vue?vue&type=script&lang=js&"
export * from "./neworder.vue?vue&type=script&lang=js&"
import style0 from "./neworder.vue?vue&type=style&index=0&id=2e074a0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e074a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
